export default "__VITE_ASSET__DUkybcbs__"